import { Component, ErrorInfo, ReactNode } from "react";

import { Result } from "@honeycomb/ui";

export type ErrorBoundaryState =
  | {
      didCatch: true;
      error: unknown;
    }
  | {
      didCatch: false;
      error: null;
    };

const initialState: ErrorBoundaryState = {
  didCatch: false,
  error: null,
};

export class ErrorBoundary extends Component<{ children?: ReactNode }, ErrorBoundaryState> {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  static getDerivedStateFromError(error: Error) {
    return { didCatch: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const errorLog = { error, errorInfo };

    console.error("Unhandled React Error", errorLog);
  }

  render() {
    const { children } = this.props;
    const { didCatch } = this.state;

    if (!didCatch) {
      return children || null;
    }

    return (
      <Result
        status="500"
        title="An unknown error occured"
        subTitle="Something went wrong. Please refresh the page and try again"
        style={{
          position: "absolute",
          width: "100%",
          top: "50%",
          transform: "translateY(-50%)",
          left: "0",
          right: "0",
        }}
      />
    );
  }
}
